import apiClient from '../apiClient/apiClient';
import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { DayRecord } from './day.type';

export const useDays = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<DayRecord[]>>({
    queryKey: 'days',
    queryFn: () => apiClient.get<DayRecord[]>('/days'),
    enabled,
  });
};